/**
 * This is the securityquestion routes configuration.
 * Only configure routes in this file.
 * @memberOf securityquestion Module
 * @namespace securityquestion Routes
 */

/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf securityquestion Module.securityquestion Routes
 * @ngInject
 */
var config = function ($stateProvider) {

	/* Create the securityquestion state and assign the template and controller. */
	$stateProvider
		.state('login.securityquestion.rsa', {
			url: '/rsa',
			template: '<ui-view>',
			controller: 'rsaController',
			controllerAs: 'rsaController'
		});
};

export default config;


// WEBPACK FOOTER //
// ./src/login/securityquestion/rsa/rsa.route.js